import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../services/api';

export const fetchGymkhanaContent = createAsyncThunk(
    'gymkhana/fetchGymkhanaContent',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get('/what-is-gymkhana/all');
            const data = response.data;
            return Array.isArray(data) ? data[0] : data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message || 'Failed to fetch Gymkhana content');
        }
    }
);

export const createGymkhanaContent = createAsyncThunk(
    'gymkhana/createGymkhanaContent',
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post('/what-is-gymkhana', data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message || 'Failed to create Gymkhana content');
        }
    }
);

export const updateGymkhanaContent = createAsyncThunk(
    'gymkhana/updateGymkhanaContent',
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const response = await api.put(`/what-is-gymkhana/${id}`, data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message || 'Failed to update Gymkhana content');
        }
    }
);

const gymkhanaSlice = createSlice({
    name: 'gymkhana',
    initialState: {
        data: null,
        status: 'idle',
        error: null,
        submitStatus: 'idle',
    },
    reducers: {
        resetSubmitStatus: (state) => {
            state.submitStatus = 'idle';
        }
    },
    extraReducers: (builder) => {
        builder
            // Fetch
            .addCase(fetchGymkhanaContent.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(fetchGymkhanaContent.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchGymkhanaContent.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })
            // Create
            .addCase(createGymkhanaContent.pending, (state) => {
                state.submitStatus = 'loading';
            })
            .addCase(createGymkhanaContent.fulfilled, (state, action) => {
                state.submitStatus = 'succeeded';
                state.data = action.payload;
            })
            .addCase(createGymkhanaContent.rejected, (state, action) => {
                state.submitStatus = 'failed';
                state.error = action.payload;
            })
            // Update
            .addCase(updateGymkhanaContent.pending, (state) => {
                state.submitStatus = 'loading';
            })
            .addCase(updateGymkhanaContent.fulfilled, (state, action) => {
                state.submitStatus = 'succeeded';
                state.data = action.payload;
            })
            .addCase(updateGymkhanaContent.rejected, (state, action) => {
                state.submitStatus = 'failed';
                state.error = action.payload;
            });
    },
});

export const { resetSubmitStatus } = gymkhanaSlice.actions;

export const selectGymkhanaData = (state) => state.gymkhana.data;
export const selectGymkhanaStatus = (state) => state.gymkhana.status;
export const selectGymkhanaSubmitStatus = (state) => state.gymkhana.submitStatus;
export const selectGymkhanaError = (state) => state.gymkhana.error;

export default gymkhanaSlice.reducer;
